//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const DEFAULT_COLORS_DARKER_TINTS = {
    color: [
        'var(--ods-cyan-dark, #085EBD)',
        'var(--ods-teal-dark, #0A6E31)',
        'var(--ods-pink-dark, #FF8AD4)',
        'var(--ods-indigo-dark, #492191)',
        'var(--ods-yellow-dark, #FFB400)',
    ],
};
